import { render, staticRenderFns } from "./PovijestIspravaka.vue?vue&type=template&id=dde0e19e&scoped=true&"
import script from "./PovijestIspravaka.vue?vue&type=script&lang=js&"
export * from "./PovijestIspravaka.vue?vue&type=script&lang=js&"
import style0 from "./PovijestIspravaka.vue?vue&type=style&index=0&id=dde0e19e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dde0e19e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VIcon,VSpacer})
